import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "conversation-container" }
const _hoisted_2 = { class: "conversation-container__body" }

import ConversationHeader from './ConversationHeader.vue';
import { ConversationMessage } from '../../models/conversation-message';
import { default as ColourPicker } from '@/shared/services/color';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationPreview',
  props: {
  brandColour: {
    type: String,
    required: true,
  },
  outboundMessageColour: {
    type: String,
    default: '#062b80',
  },
  actionColour: {
    type: String,
    required: true,
  },
  headerText: {
    type: String,
    required: true,
  },
  typicalResponseTime: {
    type: String,
    required: true,
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  messages: {
    type: Array as PropType<ConversationMessage[]>,
    required: true,
  },
  readonlyApps: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_n_conversation = _resolveComponent("n-conversation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ConversationHeader, {
      brandColour: __props.brandColour,
      outboundMessageColour: __props.outboundMessageColour,
      headerText: __props.headerText,
      subtitleText: __props.typicalResponseTime
    }, null, 8, ["brandColour", "outboundMessageColour", "headerText", "subtitleText"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_conversation, {
        readonlyApps: __props.readonlyApps,
        messages: __props.messages,
        outboundMessageColour: __props.outboundMessageColour,
        displayAvatar: __props.displayAvatar,
        enableAvatarTooltip: __props.enableAvatarTooltip,
        onSendQuickReply: _cache[0] || (_cache[0] = (quickReply) => _ctx.$emit('sendQuickReply', quickReply)),
        onMessageSend: _cache[1] || (_cache[1] = (message) => _ctx.$emit('messageSend', message)),
        onConversationRead: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('conversationRead'))),
        onTypingStart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('typingStart'))),
        onTypingStop: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('typingStop')))
      }, null, 8, ["readonlyApps", "messages", "outboundMessageColour", "displayAvatar", "enableAvatarTooltip"])
    ])
  ]))
}
}

})